module.exports = __webpack_public_path__ + "static/media/cert9.0f92adf8.jpeg";